import React from 'react';

import Rebook from '@rover/icons/svg/rebook.svg';
import { Flex, Paragraph } from '@rover/kibble/core';
import {
  FLAGS,
  useFrontendConfiguration,
} from '@rover/rsdk/src/modules/Data/Core/FrontendConfiguration';

type RepeatClientSummaryProps = {
  displayFor: 'compact' | 'full';
  repeatClientCount?: number;
};

export const RepeatClientSummary = ({
  displayFor,
  repeatClientCount,
}: RepeatClientSummaryProps): JSX.Element | null => {
  const { isFlagActive } = useFrontendConfiguration();
  const isAllServicesClientCountActive = isFlagActive(
    FLAGS.ROLLOUT_TRAINING_ALL_SERVICE_CLIENT_COUNT
  );
  const display = displayFor === 'full' ? ['none', 'flex'] : ['flex', 'none'];
  const pluralization = repeatClientCount === 1 ? '' : 's';
  const trainingLabel = isAllServicesClientCountActive ? '' : 'training ';

  return (
    <Flex gap="2x" alignItems="center" display={display} mt={['0x', '1x']}>
      <Rebook height="16px" width="16px" />
      <Paragraph mb="0x">
        {repeatClientCount} repeat {trainingLabel}client{pluralization}
      </Paragraph>
    </Flex>
  );
};
